// import {
//    Box,
//    Card,
//    CardHeader,
//    Heading,
//    CardBody,
//    Stack,
//    Text,
//    StackDivider,
//    Grid,
//    GridItem,
//    Flex,
//    IconButton,
//    useDisclosure,
//    Button,
//    useColorModeValue,
// } from '@chakra-ui/react';
// import CompanyForm from './CompanyForm';

// // Custom components
// // import Banner from 'views/admin/companyProfile/components/Banner';
// // import General from 'views/admin/companyProfile/components/General';
// // import Projects from 'views/admin/companyProfile/components/Projects';
// // import Upload from 'views/admin/companyProfile/components/Upload';

// // Assets
// // import banner from 'assets/img/auth/banner.png';
// // import avatar from 'assets/img/avatars/avatar4.png';
// import React, { useCallback, useEffect, useState } from 'react';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { getCompanies } from '../../../redux/actions/company';
// import { useParams } from 'react-router-dom';
// import { MdEdit } from 'react-icons/md';
// import { Link } from 'react-router-dom';
// import { IoMdArrowRoundBack } from 'react-icons/io';
// import { useGlobal } from '../../../contexts';

// export default function Overview() {
//    // const dispatch = useDispatch();
//    const { companyList } = useGlobal();
//    // const companyList = useSelector((state) => state.company.list);
//    const [activeCompany, setActiveCompany] = useState(null);
//    const { id } = useParams();
//    const companyId = localStorage.getItem('companyId');
//    const btnRef = React.useRef();
//    const { isOpen, onOpen, onClose } = useDisclosure();
//    const backgroundColor = useColorModeValue('white', '#101F4A');

//    const handleCompany = useCallback(() => {
//       if (id) {
//          const company = companyList?.find((company) => company.id.toString() === id.toString());
//          setActiveCompany(company);
//       } else {
//          const company = companyList?.find((company) => company.id.toString() === companyId.toString());
//          setActiveCompany(company);
//       }
//    }, [companyId, companyList, id]);

//    // Find the active company
//    useEffect(() => {
//       handleCompany();
//    }, [handleCompany]);

//    // useEffect(() => {
//    //   dispatch(getCompanies());
//    // }, [dispatch]);
//    return (
//       <>
//          <Box pt={{ base: '30px', md: '50px', xl: '30px' }}>
//             <Link to="/admin/setting">
//                <Button mb="20px">
//                   <IoMdArrowRoundBack size={18} />
//                </Button>
//             </Link>
//             <Card bg={backgroundColor}>
//                <CardHeader>
//                   <Flex justify="space-between" align="center">
//                      <Heading size="md">Company Overview</Heading>
//                      <IconButton variant="ghost" ref={btnRef} onClick={() => onOpen()} icon={<MdEdit />} />
//                   </Flex>
//                </CardHeader>

//                <CardBody>
//                   <Stack divider={<StackDivider />} spacing="4">
//                      <Box>
//                         <Grid templateColumns="repeat(2, 1fr)" gap={2}>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  GST NO
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.gstRegNo || 'N/A'}
//                               </Text>
//                            </GridItem>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Name
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.name || 'N/A'}
//                               </Text>
//                            </GridItem>
//                         </Grid>
//                      </Box>

//                      <Box>
//                         <Grid templateColumns="repeat(2, 1fr)" gap={2}>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Mobile
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.mobile || 'N/A'}
//                               </Text>
//                            </GridItem>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Email
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.email || 'N/A'}
//                               </Text>
//                            </GridItem>
//                         </Grid>
//                      </Box>

//                      <Box>
//                         <Grid templateColumns="repeat(2, 1fr)" gap={2}>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Address 1
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.address1 || 'N/A'}
//                               </Text>
//                            </GridItem>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Address 2
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.address2 || 'N/A'}
//                               </Text>
//                            </GridItem>
//                         </Grid>
//                      </Box>

//                      <Box>
//                         <Grid templateColumns="repeat(2, 1fr)" gap={2}>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Address 3
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.address3 || 'N/A'}
//                               </Text>
//                            </GridItem>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  City
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.cityname || 'N/A'}
//                               </Text>
//                            </GridItem>
//                         </Grid>
//                      </Box>

//                      <Box>
//                         <Grid templateColumns="repeat(2, 1fr)" gap={2}>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Pincode
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.pinCode || 'N/A'}
//                               </Text>
//                            </GridItem>
//                            <GridItem>
//                               <Heading size="xs" textTransform="uppercase">
//                                  Group Name
//                               </Heading>
//                               <Text pt="2" fontSize="sm">
//                                  {activeCompany?.companygroupname || 'N/A'}
//                               </Text>
//                            </GridItem>
//                         </Grid>
//                      </Box>
//                   </Stack>
//                </CardBody>
//             </Card>
//          </Box>

//          <CompanyForm isOpen={isOpen} onClose={onClose} isEditMode={true} currentRow={activeCompany} />
//          {/* // <Box pt={{ base: '130px', md: '80px', xl: '80px' }}> */}
//          {/* Main Fields */}
//          {/* <Grid
//         templateColumns={{
//           base: '1fr',
//           lg: '1.34fr 1fr 1.62fr',
//         }}
//         templateRows={{
//           base: 'repeat(3, 1fr)',
//           lg: '1fr',
//         }}
//         gap={{ base: '20px', xl: '20px' }}
//       >
//         <Banner
//           gridArea="1 / 1 / 2 / 2"
//           banner={banner}
//           avatar={avatar}
//           name={activeCompany ? activeCompany.name : 'Default Name'}
//           job={activeCompany ? activeCompany.legalName : 'Default Job'}
//           companyList={companyList}
//           posts="17"
//           followers="9.7k"
//           following="274"
//         /> */}
//          {/* <Storage
//           gridArea={{ base: "2 / 1 / 3 / 2", lg: "1 / 2 / 2 / 3" }}
//           used={25.6}
//           total={50}
//         /> */}
//          {/* <Upload
//           gridArea={{
//             base: '3 / 1 / 4 / 2',
//             lg: '1 / 3 / 2 / 4',
//           }}
//           minH={{ base: 'auto', lg: '420px', '2xl': '365px' }}
//           pe="20px"
//           pb={{ base: '100px', lg: '20px' }}
//         /> */}
//          {/* </Grid> */}
//          {/* <Grid
//         mb="20px"
//         w="full"  // Ensures the grid takes up full width
//         templateColumns={{
//           base: "1fr",          // Full width on mobile
//           lg: "repeat(1, 1fr)", // Two columns on large screens
//           "2xl": "1.34fr 1.62fr 1fr", // Custom layout for 2xl screens
//         }}
//         templateRows={{
//           base: "1fr",          // Single row on mobile
//           lg: "repeat(2, 1fr)", // Two rows on large screens
//           "2xl": "1fr",         // Single row on 2xl screens
//         }}
//         gap={{ base: "20px", xl: "20px" }} // Gap between items
//       >
//         <Projects
//           gridArea="1 / 2 / 2 / 2"
//           banner={banner}
//           avatar={avatar}
//           companyList={companyList}
//           // name="Adela Parkson"
//           // job="Product Designer"
//           posts="17"
//           followers="9.7k"
//           following="274"
//         />
//       </Grid> */}

//          {/* <Grid
//         mb='20px'
//         templateColumns={{
//           base: "1fr",
//           lg: "repeat(2, 1fr)",
//           "2xl": "1.34fr 1.62fr 1fr",
//         }}
//         templateRows={{
//           base: "1fr",
//           lg: "repeat(2, 1fr)",
//           "2xl": "1fr",
//         }}
//         gap={{ base: "20px", xl: "20px" }}>
//         <Projects
//           gridArea='1 / 2 / 2 / 2'
//           banner={banner}
//           avatar={avatar}
//           name='Adela Parkson'
//           job='Product Designer'
//           posts='17'
//           followers='9.7k'
//           following='274'
//         />
//         <General
//           gridArea={{ base: "2 / 1 / 3 / 2", lg: "1 / 2 / 2 / 3" }}
//           minH='365px'
//           pe='20px'
//         />
//       </Grid> */}
//          {/* </Box> */}
//       </>
//    );
// }

import React, { useCallback, useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useGlobal, useUser } from '../../../contexts';
import CompanyForm from './CompanyForm';
import { MdEdit } from 'react-icons/md';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { Building2, Mail, Phone, MapPin, Hash, Users } from 'lucide-react';
import { useColorMode } from '@chakra-ui/react';

export default function Overview() {
   const { companyList } = useGlobal();
   console.log("all company data", companyList);
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [activeCompany, setActiveCompany] = useState(null);
   // const { id } = useParams();
   const id = localStorage.getItem('company-view-id');
   const type = localStorage.getItem('company-view-type');
   const companyId = localStorage.getItem('companyId');
   const btnRef = React.useRef();
   const [isOpen, setIsOpen] = useState(false);
   const { user } = useUser();
   const companyRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === id)?.companyprofile
      : null;

   const handleCompany = useCallback(() => {
      if (id) {
         const company = companyList?.find((company) =>
            company.id.toString() === id.toString() &&
            (type === "regular" || company.dbName === type.toString())
         );
         setActiveCompany(company);
      } else {
         const company = companyList?.find((company) => company.id.toString() === companyId?.toString());
         setActiveCompany(company);
      }
   }, [companyId, companyList, id]);

   useEffect(() => {
      handleCompany();
   }, [handleCompany]);

   const InfoRow = ({ icon: Icon, label, value }) => (
      <div className="flex items-start gap-3 py-3">
         <div
            className={`w-9 h-9 ${isDark ? 'bg-blue-900/30' : 'bg-blue-50'
               } rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5`}>
            <Icon className={`w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
         </div>
         <div className="flex-1 min-w-0">
            <p className={`text-xs font-medium ${isDark ? 'text-gray-400' : 'text-gray-500'} mb-0.5`}>{label}</p>
            <p className={`text-sm ${isDark ? 'text-gray-200' : 'text-gray-900'} font-medium break-words`}>
               {value || 'N/A'}
            </p>
         </div>
      </div>
   );

   return (
      <>
         <div className={`min-h-screen mt-10 ${isDark ? 'bg-gray-900' : 'bg-gray-50'} p-6`}>
            <div className="max-w-5xl mx-auto">
               {/* Back Button */}
               <Link to="/admin/setting">
                  <button
                     className={`flex items-center gap-2 mb-6 px-4 py-2 ${isDark
                        ? 'bg-gray-800 border-gray-700 text-gray-300 hover:text-white hover:border-gray-600'
                        : 'bg-white border-gray-200 text-gray-600 hover:text-gray-900 hover:border-gray-300'
                        } rounded-lg shadow-sm border transition-colors`}>
                     <IoMdArrowRoundBack size={18} />
                     <span className="text-sm font-medium inline-block">Back</span>
                  </button>
               </Link>

               {/* Header Card */}
               <div
                  className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                     } rounded-xl shadow-sm border mb-6 overflow-hidden`}>
                  <div
                     className={`${isDark
                        ? 'bg-gradient-to-r from-blue-600 to-blue-700'
                        : 'bg-gradient-to-r from-blue-500 to-blue-600'
                        } px-6 py-8`}>
                     <div className="flex flex-col sm:flex-row items-start justify-between gap-4">
                        <div className="flex items-center gap-4">
                           <div className="w-14 h-14 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center">
                              <Building2 className="w-7 h-7 text-white" />
                           </div>
                           <div>
                              <h1 className="text-2xl font-bold text-white mb-1">
                                 {activeCompany?.name || 'Company Name'}
                              </h1>
                              <p className={`${isDark ? 'text-blue-200' : 'text-blue-100'} text-sm`}>
                                 GST: {activeCompany?.gstRegNo || 'N/A'}
                              </p>
                           </div>
                        </div>
                        {(user?.isAdmin || companyRight?.edit) && (!activeCompany?.dbName) && (
                           <button
                              ref={btnRef}
                              onClick={() => setIsOpen(true)}
                              className={`flex items-center gap-2 px-4 py-2 ${isDark
                                 ? 'bg-white/10 text-white hover:bg-white/20'
                                 : 'bg-white text-blue-600 hover:bg-blue-50'
                                 } rounded-lg transition-colors`}>
                              <MdEdit size={18} />
                              <span className="text-sm font-medium">Edit</span>
                           </button>
                        )}
                     </div>
                  </div>
               </div>

               {/* Content Grid */}
               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Contact Information */}
                  <div
                     className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                        } rounded-xl shadow-sm border p-6`}>
                     <h2 className={`text-base font-semibold ${isDark ? 'text-gray-100' : 'text-gray-900'} mb-4`}>
                        Contact Information
                     </h2>
                     <div className="space-y-1">
                        <InfoRow icon={Phone} label="Mobile" value={activeCompany?.mobile} />
                        <InfoRow icon={Mail} label="Email" value={activeCompany?.email} />
                     </div>
                  </div>

                  {/* Business Details */}
                  <div
                     className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                        } rounded-xl shadow-sm border p-6`}>
                     <h2 className={`text-base font-semibold ${isDark ? 'text-gray-100' : 'text-gray-900'} mb-4`}>
                        Business Details
                     </h2>
                     <div className="space-y-1">
                        <InfoRow icon={Hash} label="GST Number" value={activeCompany?.gstRegNo} />
                        <InfoRow icon={Users} label="Company Group" value={activeCompany?.companygroupname} />
                     </div>
                  </div>

                  {/* Address Details */}
                  <div
                     className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
                        } rounded-xl shadow-sm border p-6 md:col-span-2`}>
                     <h2 className={`text-base font-semibold ${isDark ? 'text-gray-100' : 'text-gray-900'} mb-4`}>
                        Address Information
                     </h2>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
                        <div className="space-y-1">
                           <InfoRow icon={MapPin} label="Address Line 1" value={activeCompany?.address1} />
                           <InfoRow icon={MapPin} label="Address Line 2" value={activeCompany?.address2} />
                        </div>
                        <div className="space-y-1">
                           <InfoRow icon={MapPin} label="Address Line 3" value={activeCompany?.address3} />
                           <InfoRow icon={MapPin} label="City" value={activeCompany?.cityname} />
                           <InfoRow icon={MapPin} label="PIN Code" value={activeCompany?.pinCode} />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <CompanyForm isOpen={isOpen} onClose={() => setIsOpen(false)} isEditMode={true} currentRow={activeCompany} />
      </>
   );
}
